// Comprehensive Cardiovascular Naming Data
// English names + Latin names following Terminologia Anatomica

export const CARDIO_NAMES = {
  "Cardiac": { english: "Heart", latin: "Cor" },
  "abdomen_inferior_vena_cavav_Veins": { english: "Inferior Vena Cava", latin: "Vena Cava Inferior" },
  "Gut_Veins": { english: "Mesenteric & Portal Veins", latin: "Venae Mesentericae et Portae" },
  "Head_neck001_Veins": { english: "Jugular Veins", latin: "Venae Jugulares" },
  "Kidney__Veins_L_001": { english: "Left Renal Vein", latin: "Vena Renalis Sinistra" },
  "Kidney__Veins_R": { english: "Right Renal Vein", latin: "Vena Renalis Dextra" },
  "Liver_Veins": { english: "Hepatic Veins", latin: "Venae Hepaticae" },
  "Lower_limb_Veins_L": { english: "Left Femoral Veins", latin: "Venae Femoralis Sinistra" },
  "Lower_limb_Veins_R": { english: "Right Femoral Veins", latin: "Venae Femoralis Dextra" },
  "Pelvis_Veins_001": { english: "Common Iliac Veins", latin: "Venae Iliacae Communes" },
  "Pulmonary_Veins_L_001": { english: "Left Pulmonary Veins", latin: "Venae Pulmonales Sinistrae" },
  "Pulmonary_Veins_R": { english: "Right Pulmonary Veins", latin: "Venae Pulmonales Dextrae" },
  "Superior_vena_cava_Veins": { english: "Superior Vena Cava", latin: "Vena Cava Superior" },
  "thorax_Veins": { english: "Azygos System", latin: "Vena Azygos" },
  "Upper_limb_Veins_L": { english: "Left Subclavian Vein", latin: "Vena Subclavia Sinistra" },
  "Upper_limb_Veins_R": { english: "Right Subclavian Vein", latin: "Vena Subclavia Dextra" },
  "Abdomen_aorta_abdominalis_arteries": { english: "Abdominal Aorta", latin: "Aorta Abdominalis" },
  "Aortic_arteries": { english: "Arch of Aorta", latin: "Arcus Aortae" },
  "Gut_arteries": { english: "Mesenteric Arteries", latin: "Arteriae Mesentericae" },
  "Head_neck_arteries": { english: "Carotid Arteries", latin: "Arteriae Carotides Communes" },
  "Kidney__arteries_L": { english: "Left Renal Artery", latin: "Arteria Renalis Sinistra" },
  "Kidney__arteries_R_001": { english: "Right Renal Artery", latin: "Arteria Renalis Dextra" },
  "Liver_arteries": { english: "Hepatic Artery", latin: "Arteria Hepatica Propria" },
  "Lower_limb_arteries_L_001": { english: "Left Femoral Artery", latin: "Arteria Femoralis Sinistra" },
  "Lower_limb_arteries_R": { english: "Right Femoral Artery", latin: "Arteria Femoralis Dextra" },
  "Pelvis_arteries": { english: "Common Iliac Arteries", latin: "Arteriae Iliacae Communes" },
  "Pulmonary_inferior___arteries_L": { english: "Left Inferior Pulmonary Artery", latin: "Arteria Pulmonalis Sinistra Inferior" },
  "Pulmonary_inferior_arteries_R": { english: "Right Inferior Pulmonary Artery", latin: "Arteria Pulmonalis Dextra Inferior" },
  "Pulmonary_superior_arteries_L_001": { english: "Left Superior Pulmonary Artery", latin: "Arteria Pulmonalis Sinistra Superior" },
  "Pulmonary_superior_arteries_R": { english: "Right Superior Pulmonary Artery", latin: "Arteria Pulmonalis Dextra Superior" },
  "thorax_arteries_001": { english: "Thoracic Aorta", latin: "Aorta Thoracica" },
  "Upper_limb_arteries_L": { english: "Left Subclavian Artery", latin: "Arteria Subclavia Sinistra" },
  "Upper_limb_arteries_R": { english: "Right Subclavian Artery", latin: "Arteria Subclavia Dextra" },
  "Aortaa": { english: "Ascending Aorta", latin: "Aorta Ascendens" },
  "Aortic_valve": { english: "Aortic Valve", latin: "Valva Aortae" },
  "Back_Heart": { english: "Posterior Surface of Heart", latin: "Facies Posterior Cordis" },
  "Capslice_Type2": { english: "Heart Cross-section", latin: "Myocardium" },
  "Mitral_valve": { english: "Mitral Valve", latin: "Valva Mitralis" },
  "Pulmonary_valve": { english: "Pulmonary Valve", latin: "Valva Trunci Pulmonalis" },
  "Pulmonary_vein_": { english: "Pulmonary Veins", latin: "Venae Pulmonales" },
  "Pulmoneryartery": { english: "Pulmonary Trunk", latin: "Truncus Pulmonalis" },
  "Tricuspic_valve": { english: "Tricuspid Valve", latin: "Valva Tricuspidalis" },
};

export function getCardioInfo(meshName) {
  if (!meshName) return { english: "Unknown Structure", latin: "Incertum" };
  
  // Try exact match
  if (CARDIO_NAMES[meshName]) return CARDIO_NAMES[meshName];

  // Robust cleanup and lookup
  let clean = meshName.replace(/_/g, ' ').replace(/\d+$/, '').trim();
  
  // Expand common suffixes
  if (clean.endsWith(' L')) clean = clean.substring(0, clean.length - 2) + ' (Left)';
  else if (clean.endsWith(' R')) clean = clean.substring(0, clean.length - 2) + ' (Right)';

  return { english: clean, latin: clean };
}
